import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Skip Auth0, POS, logging, and PDF endpoints
        if (req.url.includes('auth0.com')) {
            return next.handle(req);
        }

        return this.authService.getUserToken$().pipe(
            switchMap((token: string | null) => {
                // Inject /gateway/api into URLs that target the gateway
                let modifiedUrl = req.url;

                if (req.url.includes('plugpoint.ro') && !req.url.includes('/gateway/api')) {
                    modifiedUrl = req.url.replace('plugpoint.ro/', 'plugpoint.ro/gateway/api/');
                }

                const authReq = token
                    ? req.clone({ url: modifiedUrl, setHeaders: { Authorization: `Bearer ${token}` } })
                    : req.clone({ url: modifiedUrl });

                return next.handle(authReq);
            }),
            catchError((error: unknown) => {
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    // Unauthorized - token expired or invalid
                    this.authService.logout();
                }
                else if (error instanceof HttpErrorResponse && error.status === 403) {
                    // Forbidden - user lacks permissions
                }
                return throwError(() => error);
            })
        );
    }
}

